// Gates "previous week" navigation behind the Free-tier history wall.
import { useCallback, useState } from 'react';

export function useDashboardHistoryWall({
  isFree,
  setWeekOffset,
  setOpenDay,
  setProjectFilter,
}) {
  const [historyWallOpen, setHistoryWallOpen] = useState(false);

  const handlePreviousWeek = useCallback(() => {
    if (isFree) {
      setHistoryWallOpen(true);
      return;
    }
    setWeekOffset((offset) => offset + 1);
    setOpenDay(0);
    setProjectFilter(null);
  }, [isFree, setWeekOffset, setOpenDay, setProjectFilter]);

  const closeHistoryWall = useCallback(() => setHistoryWallOpen(false), []);

  return { historyWallOpen, closeHistoryWall, handlePreviousWeek };
}
